
export default {

    "e-mail" : "e-mail",
    "password" : "password",
    "wrong_email_password" : "Wrong e-mail or password",
    "login" : "Log-In"

}
